import { cn } from '@forest/shared'

export function CakeBoxIcon(props: { class?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24.0009"
      fill="none"
      aria-hidden="true"
      class={cn('shrink-0', props.class)}
    >
      <path
        opacity="0.1"
        d="M12.0008 24.0009C8.90448 24.0009 5.76504 23.9563 2.66869 23.867C1.51005 23.832 0.490642 22.9796 0.298363 21.8819C-0.0994544 19.5908 -0.0994544 17.271 0.298363 14.9816C0.490642 13.8806 1.51005 13.0283 2.66704 12.9932C5.76338 12.904 8.90283 12.8594 11.9992 12.8594C15.0955 12.8594 18.235 12.904 21.3313 12.9932C22.49 13.0283 23.5077 13.8806 23.7016 14.9784C24.0995 17.2694 24.0995 19.5908 23.7016 21.8787C23.5077 22.9796 22.49 23.832 21.333 23.8654C18.235 23.9547 15.0955 23.9993 11.9992 23.9993L12.0008 24.0009Z"
        fill="black"
      />
      <path
        d="M22.3437 7.46875H1.65723V18.4302H22.3437V7.46875Z"
        fill="#7B72F2"
      />
      <path
        d="M21.283 11.3118C15.0953 11.4886 8.90594 11.4886 2.71822 11.3118C2.35355 11.3006 1.99552 11.0059 1.93419 10.6554C1.56621 8.53159 1.56621 6.40621 1.93419 4.28243C1.99552 3.93033 2.35355 3.63558 2.71822 3.62602C8.90594 3.44758 15.0953 3.44758 21.283 3.62602C21.6477 3.63717 22.0057 3.93192 22.0671 4.28243C22.4351 6.40621 22.4351 8.53159 22.0671 10.6554C22.0057 11.0075 21.6477 11.3022 21.283 11.3118Z"
        fill="#9C91F6"
      />
      <path
        d="M21.283 22.2747C15.0953 22.4515 8.90594 22.4515 2.71822 22.2747C2.35355 22.2635 1.99552 21.9688 1.93419 21.6183C1.56621 19.4945 1.56621 17.3691 1.93419 15.2453C1.99552 14.8932 2.35355 14.5985 2.71822 14.5889C8.90594 14.4105 15.0953 14.4105 21.283 14.5889C21.6477 14.6001 22.0057 14.8948 22.0671 15.2453C22.4351 17.3691 22.4351 19.4945 22.0671 21.6183C22.0057 21.9704 21.6477 22.2651 21.283 22.2747Z"
        fill="#7B72F2"
      />
      <path
        d="M15.3819 15.7406C15.1714 15.5685 13.8586 15.5701 12.7862 16.1851C12.4514 16.3763 12.1928 16.6025 12.0005 16.8272C11.8099 16.6025 11.5496 16.3763 11.2148 16.1851C10.144 15.5701 8.83122 15.5685 8.61905 15.7406C8.39528 15.9222 8.50136 16.9069 9.57381 17.5218C10.2501 17.9106 11.0524 18.0827 11.6275 18.0954C11.5828 18.6976 11.5248 19.5038 11.5248 19.5038C11.5049 20.1507 12.4945 20.1507 12.4746 19.5038L12.3718 18.0954C12.947 18.0827 13.7492 17.9106 14.4255 17.5218C15.4963 16.9069 15.6024 15.9222 15.3803 15.7406H15.3819Z"
        fill="white"
      />
      <path
        d="M9.34863 7.60763L13.7313 6.07812C17.7194 7.27305 21.1655 11.5907 21.1638 14.3677L19.0057 13.9471L17.4807 15.8016C16.3138 12.142 12.6422 8.83601 9.35029 7.60763H9.34863Z"
        fill="#FFDE79"
      />
      <path
        d="M12.0008 3.40904C13.0003 1.81421 15.5132 -0.972359 19.5942 0.342059C22.8148 1.38085 22.8844 4.73779 21.7391 6.63693C20.2506 9.10326 16.0155 8.62847 12.0025 7.41283L11.1737 5.1839L12.0025 3.40744L12.0008 3.40904Z"
        fill="#FFDE79"
      />
      <path
        d="M19.6152 6.69203C17.3212 7.85509 14.2364 7.01227 13.2518 6.45782C14.2845 5.03665 16.2968 3.12637 19.2191 4.06319C20.817 4.57462 20.6927 6.14714 19.6152 6.69203Z"
        fill="#EBA14D"
      />
      <path
        d="M14.6526 7.60763L10.27 6.07812C6.28184 7.8498 2.93354 11.4202 2.64844 14.3677L4.611 13.9853L6.33156 15.8016C6.7559 12.6024 11.3606 8.83601 14.6526 7.60763Z"
        fill="#FFDE79"
      />
      <path
        d="M12.0009 3.40904C11.0031 1.81421 8.48855 -0.972359 4.40926 0.342059C1.18694 1.37925 1.11732 4.73779 2.26436 6.63693C3.75287 9.10326 7.98796 8.62847 12.0009 7.41283L12.8297 5.1839L12.0009 3.40744V3.40904Z"
        fill="#FFDE79"
      />
      <path
        d="M4.38579 6.69203C6.67988 7.85509 9.76462 7.01227 10.7492 6.45782C9.71655 5.03665 7.70426 3.12637 4.78195 4.06319C3.18405 4.57462 3.30837 6.14714 4.38579 6.69203Z"
        fill="#EBA14D"
      />
    </svg>
  )
}
